// Staff sessions: provider staff open this portal signed in as a client (see backend services/staff_session.py).
/** Tokens arrive in the URL fragment, which browsers never send to a server. */
export function parseStaffFragment(hash) {
  const params = new URLSearchParams(String(hash || '').replace(/^#/, ''));
  const accessToken = params.get('access_token');
  const refreshToken = params.get('refresh_token');
  return accessToken && refreshToken ? { accessToken, refreshToken } : null;
}

export function describeStaffSession(status) {
  if (!status?.active) return null;
  const until = status.until ? new Date(status.until).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' }) : null;
  return `Staff session: ${status.staff_email || 'provider staff'} is acting for this client${until ? ` until ${until}` : ''}. Payments are disabled.`;
}
